import { render, staticRenderFns } from "./BsAppbarItems.vue?vue&type=template&id=4c8038dd&scoped=true&"
import script from "./BsAppbarItems.vue?vue&type=script&lang=js&"
export * from "./BsAppbarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8038dd",
  null
  
)

export default component.exports